import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import type { BookingValidationErrors } from '../../../services/update-form/updateBookingReducer';
import { getValidationErrors } from '../../../services/update-form/updateFormReducer';
import type { StoreState } from '../../../store/storeState';
import { useBookingFormInstanceId } from '../BookingFormInstanceIdProvider';

export const useUpdateValidationErrors = <TKey extends keyof BookingValidationErrors>(
  name: TKey,
) => {
  const formId = useBookingFormInstanceId();

  const mapState = useCallback(
    (state: StoreState): BookingValidationErrors[TKey] => {
      return getValidationErrors(state, formId)?.[name];
    },
    [formId, name],
  );

  return useSelector(mapState);
};
